import React from 'react'

interface MultiScreenToggleProps {
  isActive: boolean
  onToggle: () => void
}

function MultiScreenToggle({ isActive, onToggle }: MultiScreenToggleProps) {
  return (
    <div className="flex items-center gap-2 rounded bg-gradient px-4 py-3">
      <span className="text-xl font-medium text-neutralColour">
        MultiScreen Mode
      </span>
      <button
        type="button"
        onClick={onToggle}
        className={`relative h-6 w-12 rounded-full transition-colors ${
          isActive ? 'bg-[#28A745]' : 'bg-gray-300'
        }`}
      >
        <span
          className={`absolute left-0.5 top-0.5 h-5 w-5 rounded-full bg-white transition-transform ${
            isActive ? 'translate-x-6' : 'translate-x-0'
          }`}
        />
      </button>
    </div>
  )
}

export default MultiScreenToggle
